<script setup lang="ts">
import { CardAdmin } from '@shared/ui/cards'
import { AppText } from '@shared/ui/typography'
import { IconCopy } from '@shared/ui/icons'

defineOptions({
  name: 'TaskInfoLayer',
})

withDefaults(defineProps<TaskInfoLayerProps>(), {
  label: '',
  taskId: null,
})

interface TaskInfoLayerProps {
  title: string
  label?: string
  taskId?: number | string | null
}
</script>

<template>
  <div class="task-info">
    <CardAdmin
      :flexible="true"
      :fullwidth="true"
    >
      <template #title>
        <div class="task-info__head">
          <AppText
            name="h3"
            color="slate-900"
          >
            {{ title }}
            <span
              v-if="label || taskId"
            >
              :
            </span>
          </AppText>
          <AppText
            v-if="label"
            name="h3"
            color="slate-900"
          >
            {{ label }}
          </AppText>
          <div
            v-if="taskId !== null"
            class="task-info__id"
          >
            <AppText
              name="body1-medium"
              color="slate-500"
            >
              #{{ taskId }}
            </AppText>
            <IconCopy
              :value="String(taskId)"
              tooltip="Copy ID"
            />
          </div>
        </div>
      </template>
      <template #header>
        <div class="task-info__actions">
          <slot name="actions" />
        </div>
      </template>
      <div class="task-info__body">
        <div class="task-info__main">
          <div
            v-if="$slots.general"
            class="task-info__general"
          >
            <AppText
              name="body1-medium"
            >
              General<span class="task-info__required">*</span>
            </AppText>
            <slot
              name="general"
            />
          </div>
          <div
            v-if="$slots.responsible"
            class="task-info__box"
          >
            <AppText
              name="body1-medium"
            >
              Responsible<span class="task-info__required">*</span>
            </AppText>
            <slot
              name="responsible"
            />
          </div>
          <div
            v-if="$slots.relations"
            class="task-info__box"
          >
            <AppText
              name="body1-medium"
            >
              Relations<span class="task-info__required">*</span>
            </AppText>
            <slot
              name="relations"
            />
          </div>
          <div
            v-if="$slots.common"
            class="task-info__box"
          >
            <slot
              name="common"
            />
          </div>
        </div>
        <div class="task-info__line" />
        <div class="task-info__side">
          <slot />
        </div>
      </div>
    </CardAdmin>
  </div>
</template>

<style scoped lang="scss" src="./TaskInfoLayer.scss" />
